import React from "react";
import "./PromotionalBannerDetailComponent.css";
import GoogleMap from "./GoogleMap";
import MapComponent from "./GoogleMap";
import GoogleMapsComponent from "./GoogleMap";



const PromotionalBannerDetailComponent = ({
  formData,
  setFormData,
  errorMessage,
  setErrorMessage,
  promotionalDetail,
  bannerUrl,
  handleContactUs,
}) => {
  const apiKey = "AIzaSyBs6nrmbsbRfKrWRCvRa__u1PgLd351guU"; // Replace with your actual API key
  const apiOptions = {}; // Add any additional API options if needed
  const handleLoadFailed = (error) => {
    console.error("Google Maps failed to load:", error);
  };
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      <img
        src={bannerUrl}
        className="w-100"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "/Images/banner-default.jpg";
        }}
      />
      <div className="container">
        <div className="vendor-main-product">
          <div className="row">
            <div className="col-lg-12 col-12 mb_padding_0">
              <div className="affiliate_partner_shd ">
                <h4 className="common_heading mb_commn_pd_0">
                  About Our Company{" "}
                </h4>
                {promotionalDetail?.BannerDescription}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="vendor-main-product">
          <div className="row">
            <div className="col-lg-12 col-12 mb_padding_0">
              <div className="promotional-detail-main">
                <h4 className="common_heading mb_commn_pd_0">Get In Touch </h4>
                <div className="col-12 row">
                  <div className="col-4">
                    <div className="form about_form">
                      <p>
                        <strong>Adress: </strong>
                        {promotionalDetail?.Address}
                      </p>
                      <p>
                        <strong>Email: </strong>
                        {promotionalDetail?.Email}
                      </p>
                      <p>
                        <strong>Phone: </strong>{" "}
                        {promotionalDetail?.PhoneNumber}
                      </p>
                    </div>
                  </div>
                  <div className="col-8">
                    <div className="form about_form">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="required-label">Full Name</label>
                            <input
                              className="form-control"
                              type="text"
                              name="Name"
                              placeholder="Name"
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  Username: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  Username: "",
                                });
                              }}
                              value={formData?.Username}
                            />
                          </div>
                          {errorMessage?.Username && (
                            <div className="validation-message">
                              {errorMessage?.Username}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="required-label">Email</label>
                            <input
                              className="form-control"
                              type="email"
                              name="Email"
                              placeholder="user@example.com"
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  UserEmail: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  UserEmail: "",
                                });
                              }}
                              value={formData?.UserEmail}
                            />
                          </div>
                          {errorMessage?.UserEmail && (
                            <div className="validation-message">
                              {errorMessage?.UserEmail}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="required-label">Phone No</label>
                            <input
                              className="form-control"
                              type="number"
                              name="PhoneNo"
                              maxLength="10"
                              placeholder="Your Phone Number"
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  PhoneNumber: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  PhoneNumber: "",
                                });
                              }}
                              value={formData?.PhoneNumber}
                            />
                          </div>
                          {errorMessage?.PhoneNumber && (
                            <div className="validation-message">
                              {errorMessage?.PhoneNumber}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="required-label">Address</label>
                            <input
                              className="form-control"
                              type="text"
                              name="Address"
                              placeholder="Your Address"
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  Address: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  Address: "",
                                });
                              }}
                              value={formData?.Address}
                            />
                          </div>
                          {errorMessage?.Address && (
                            <div className="validation-message">
                              {errorMessage?.Address}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="required-label">Query</label>
                            <textarea
                              id="w3review"
                              name="Description"
                              rows="4"
                              className="form-control"
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  Query: e.target.value,
                                });
                                setErrorMessage({ ...errorMessage, Query: "" });
                              }}
                              value={formData?.Query}
                            ></textarea>
                          </div>
                          {errorMessage?.Query && (
                            <div className="validation-message">
                              {errorMessage?.Query}
                            </div>
                          )}
                        </div>
                      </div>
                      <button
                        type="button"
                        className="common_btn view-data-btn m-0"
                        onClick={handleContactUs}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {promotionalDetail?.Latitude && promotionalDetail?.Longitude ? (
        <div className="container">
        <div className="vendor-main-product">
          <div className="row">
            <div className="col-lg-12 col-12 mb_padding_0">
              <div className="promotional-detail-main">
              <GoogleMapsComponent apiKey={apiKey} apiOptions={apiOptions} onLoadFailed={handleLoadFailed} />
              </div>
            </div>
          </div>
        </div>
        </div>
      ) : (
        <p>No location available</p>
      )}
    </div>
  );
};

export default PromotionalBannerDetailComponent;
